import { isWeb } from '@/constants/environment'
import { Alert } from 'react-native'

export function showAlert(message: string, title?: string) {
    if (isWeb) {
        window.alert(title ? `${title}\n${message}` : message)
    } else {
        Alert.alert(title ?? '', message)
    }
}
